module.exports = __webpack_public_path__ + "static/the-beginning-of-infinity-3f37cb1ae53fb029aa161005cb3b41b4.jpg";